"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackNetworkState = void 0;
/**
 * Wraps HTTP sender and monitors online/offline network state.
 * It's a pass-through interceptor.
 * @param send - send stack
 * @param monitor - network monitor to analyse responses
 */
const trackNetworkState = (networkMonitor, send) => async (request) => {
    // intercept responses and errors
    const response = send(request)
        .then((response) => {
        networkMonitor.processResponse(response);
        return response;
    })
        .catch((error) => {
        networkMonitor.processResponseError(error);
        throw error;
    });
    return response;
};
exports.trackNetworkState = trackNetworkState;
